<article>
  <opac-skeleton class="fake-cover"></opac-skeleton>
  <div>
    <opac-skeleton class="fake-title"></opac-skeleton>
    <opac-skeleton class="fake-author"></opac-skeleton>
    <opac-skeleton class="fake-button"></opac-skeleton>
  </div>
</article>
